export enum MatchStateEnum {
  New = 'New',
  Live = 'Live',
  InProgress = 'InProgress',
  Processed = 'Processed',
  ToBeTreated = 'ToBeTreated',
}

export const allMatchStates = Object.keys(MatchStateEnum);